import { useState } from 'react';
import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  Badge,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useTheme } from '@mui/material/styles';
import { useNotifications } from '../hooks/useNotifications';
import NotificationList from './NotificationList';

interface HeaderProps {
  drawerWidth: number;
  handleDrawerToggle: () => void;
  toggleTheme: () => void;
  onLogout?: () => void;
}

export default function Header({ drawerWidth, handleDrawerToggle, toggleTheme, onLogout }: HeaderProps) {
  const theme = useTheme();
  const { unreadCount } = useNotifications();
  const [notificationOpen, setNotificationOpen] = useState(false);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: { xs: '100%', md: `calc(100% - ${drawerWidth}px)` },
          ml: { xs: 0, md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Glasska ERP
          </Typography>
          <IconButton 
            color="inherit" 
            onClick={() => setNotificationOpen(true)}
            sx={{ mr: 1 }}
            title="Notifications"
          >
            <Badge badgeContent={unreadCount} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton color="inherit" onClick={toggleTheme}>
            {theme.palette.mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
          </IconButton>
          {onLogout && (
            <IconButton color="inherit" onClick={onLogout} title="Logout">
              <LogoutIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      <NotificationList 
        open={notificationOpen} 
        onClose={() => setNotificationOpen(false)} 
      />
    </>
  );
}
